import * as appStore from './action-type';
import platform from "Pub/js/platform";
const { setMessageRelation } = platform;
import { setStore } from "Pub/js/storageUtils";

// 初始化应用数据
export const initAppData = (value) => {
    return {
        type: appStore.INITAPPDATA,
        value
    };
};
// 切换语言
export const changeIntlData = (value) => {
    return {
        type: appStore.CHANGELANG,
        value
    };
};
// 个人信息栏是否展开
export const changeDrawer = (value) => {
    return {
        type: appStore.DRAWEROPEN,
        value
    };
};
// 全部应用是否展开
export const allAppsChangeDrawer = (value) => {
    return {
        type: appStore.ALLAPPSDRAWEROPEN,
        value
    }
}
// 账户信息
export const setAccountInfo = (value) => {
    return {
        type: appStore.ACCOUNTINFO,
        value
    };
};
// 用户图标修改
export const setAvatar = (value) => {
    return {
        type: appStore.AVATAREDIT,
        value
    };
};
// 用户邮箱修改
export const setEmail = (value) => {
    return {
        type: appStore.EMAIL,
        value
    };
};
// 用户手机号修改
export const setUserPhone = (value) => {
    return {
        type: appStore.PHONE,
        value
    };
};
// 云账号绑定成功
export const bindSuccess = () => {
    return {
        type: appStore.ACCOUNTACTIVATION,
    }
}
// 获取所有消息
export const setMessageData = (data) => {
    return {
        type: appStore.SETMESSAGEDATA,
        data
    }
}
// 存储知识条目
export const setKnowledge = (data) => {
    return {
        type: appStore.SETKNOWLEDGE,
        data
    }
}
// 存储知识权限
export const setKnowledgeRule = (data) => {
    return {
        type: appStore.SETKNOWLEDGERULE,
        data
    }
}
// 存储最近访问
export const setRecent = (data) => {
    return {
        type: appStore.SETRECENT,
        data
    }
}
// 存储知识管理是否具有安装及请求权限
export const setKnowledgeRuleOnce = (data) => {
    return {
        type: appStore.SETKNOWLEDGERULEONCE,
        data
    }
}
// 开启勿扰模式
export const setDisturbMode = (data) => {
    return {
        type: appStore.SETDISTURBMODE,
        data
    }
}
// 个人信息栏是否展开
export const changeError = (value) => {
    return {
        type: appStore.ERROR,
        value
    };
};
export const setNewMsg = (data) => {
    return {
        type: appStore.SETNEWMSG,
        data
    }
}
export const changeIsAccountSettingSpr = (data) => {
    return {
        type: appStore.ISACCOUNTSETTINGSPR,
        data
    }
}
// 切换背景 
export const changeBgState = (data) => {
    return {
        type: appStore.SETBACKGROUNDSTATE,
        data
    }
}
// 设置字体
export const setNccFont = (data) => {
    return {
        type: appStore.NCCFONT,
        data
    }
}
// 切换主题色
export const setThemeColor = (themeColor) => {
    return {
        type: appStore.SETTHEMECOLOR,
        themeColor
    }
}
// 点击面包屑
export const setBreadCrumbClick = (breadCrumbClick) => {
    return {
        type: appStore.BREADCRUMBCLICK,
        breadCrumbClick
    }
}
// 工作台数据更新
export const setWorkbenchData = (workbenchData) => {
    const actived = workbenchData.find(bench => bench.active);
    if (actived) {
        setStore('activeWorkbench', actived.workbenchid);
    }
    return {
        type: appStore.SETWORKBENCHDATA,
        workbenchData
    }
}
// 设置工作台主键
export const setWorkbenchId = (workbenchId) => {
    return {
        type: appStore.SETWORKBENCHID,
        workbenchId
    }
}
// 设置联动数据
export const setLinkageData = (linkageData = []) => {
    const linkRelation = {};
    linkageData.forEach(({ source_partid, linkConfigVO = [] }) => {
        if (linkConfigVO.length) {
            linkRelation[source_partid] = linkConfigVO.map(item => item.key);
        }
    });
    setMessageRelation && setMessageRelation(linkRelation);
    return {
        type: appStore.SETLINKAGEDATA,
        linkageData
    }
}
// 设置水印信息
export const setWatermarkInfo = (watermarkInfo) => {
    return {
        type: appStore.SETWATERMARKINFO,
        watermarkInfo
    }
}